import React from 'react'
import Spin from 'antd/lib/spin'
import { Icon, IconSize } from './Icon'

type Props = {
    size?: IconSize
}

export const Spinner = ({ size = 8 }: Props): JSX.Element => {
    return <Spin indicator={<Icon iconKey="Loading" spin size={size} color="activity" />} />
}
